import { useState } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import PropTypes from "prop-types";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {
  MdSearch,
  MdSettings,
  MdExpandMore,
  MdFeed,
  MdExitToApp,
  MdClose,
} from "react-icons/md";
import { StyledDrawerLink } from "../Link";
import {
  SearchBoxWrapper,
  StyledAppBar,
  StyledDrawer,
  StyledDrawerHeader,
  StyledInputBase,
  StyledList,
  StyledMain,
  StyledSearch,
  StyledTypo,
  StyledAccordion,
  StyledAccordionDetails,
  StyledSetting,
} from "./Drawer.style";
import { useLocation } from "react-router-dom";
import AccordionSummary from "@mui/material/AccordionSummary";
import useAuth from "hooks/use-auth";
import { useForm } from "react-hook-form";
import ImgContainer from "components/shared/Image";
import logo from "assets/img/logo-512.png";
import CommentIcon from "@mui/icons-material/Comment";
import { Call, PeopleAlt, Public, Videocam } from "@mui/icons-material";
import { RiAdvertisementFill } from "react-icons/ri";
const drawerWidth = 260;
let ADMIN_PREMISSION = { isPrimary: true, isMutated: false };

const ListItems = [
  {
    label: "آگهی",
    icon: <RiAdvertisementFill size={26} />,
    url: "/adv",
  },
  {
    label: "وبلاگ ها",
    icon: <CommentIcon size={26} />,
    url: "/blogs",
  },
  {
    label: "ویدئو ها",
    icon: <Videocam size={26} />,
    url: "/videos",
  },
  {
    label: "مشاوره",
    icon: <PeopleAlt size={26} />,
    url: "/advice",
  },
  {
    label: "درباره ما",
    icon: <MdFeed size={26} />,
    url: "/about_us",
  },
  {
    label: "تماس باما",
    icon: <Call size={26} />,
    url: "/contact_us",
  },
];

const AccordionListItems = [
  {
    label: "تنظیمات",
    items: [
      {
        label: " header",
        icon: <MdFeed size={22} />,
        url: "/header",
      },
      {
        label: "متا تگ ها",
        icon: <Public size={22} />,
        url: "/meta_tags",
      },
    ],
  },
];

export default function DrawerCM(props) {
  const location = useLocation();
  const AuthCTX = useAuth();
  const currentPath = location.pathname.split()[0];
  const { register, getValues, reset } = useForm();

  const [openAccod, setOpenAccord] = useState();

  const [open, setOpen] = useState(window.innerWidth > 900 ? true : false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleChangeAccordion = (panel) => (event, isExpanded) => {
    setOpenAccord(isExpanded ? panel : false);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <StyledAppBar position="fixed" open={open} $drawerWidth={drawerWidth}>
        <Toolbar sx={{ color: (theme) => theme.palette.primary.contrastText }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton>

          <StyledTypo variant="h6" noWrap component="div">
            {props.title}
          </StyledTypo>

          {props.onSearch && (
            <StyledSearch>
              <SearchBoxWrapper>
                <IconButton
                  aria-label="close"
                  sx={{ color: "white", mr: 0.5 }}
                  onClick={() => {
                    reset({ search: "" });
                    props.onSearch("");
                  }}
                >
                  <MdClose size={20} />
                </IconButton>

                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  light
                />

                <IconButton
                  aria-label="search"
                  sx={{ color: "white", ml: 0.5 }}
                  onClick={() => props.onSearch(getValues("search"))}
                >
                  <MdSearch size={20} />
                </IconButton>
              </SearchBoxWrapper>

              <StyledInputBase
                placeholder="جستجو"
                inputProps={{ "aria-label": "search" }}
                onKeyDown={(e) =>
                  e.key === "Enter" ? props.onSearch(getValues("search")) : ""
                }
                {...register("search")}
              />
            </StyledSearch>
          )}
        </Toolbar>
      </StyledAppBar>

      <StyledDrawer
        $drawerWidth={drawerWidth}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <StyledDrawerHeader minH={"135px !important"}>
          <ImgContainer
            src={logo}
            alt="لوگو"
            objectFit="contain"
            width="150px"
            height="150px"
            sx={{ padding: "20px" }}
          />
          <IconButton
            onClick={handleDrawerClose}
            sx={{ mt: 1, alignSelf: "flex-start" }}
            size="large"
          >
            <ChevronRightIcon sx={{ color: "white" }} />
          </IconButton>
        </StyledDrawerHeader>

        <Divider />

        <StyledList>
          {ADMIN_PREMISSION.isPrimary
            ? ListItems.map((item) => (
                <StyledDrawerLink
                  to={item.url}
                  $isActive={item.url === currentPath}
                  key={item.label}
                >
                  <ListItem button>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText>{item.label}</ListItemText>
                  </ListItem>
                </StyledDrawerLink>
              ))
            : ListItems.map((item) => {
                if (ADMIN_PREMISSION[item.url])
                  return (
                    <StyledDrawerLink
                      to={item.url}
                      $isActive={item.url === currentPath}
                      key={item.label}
                    >
                      <ListItem button>
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText>{item.label}</ListItemText>
                      </ListItem>
                    </StyledDrawerLink>
                  );
              })}

          {AccordionListItems?.map((accordion, index) => (
            <StyledAccordion
              key={"drawerAccord" + index}
              expanded={
                Boolean(openAccod === index) ||
                Boolean(
                  accordion.items.find((item) => item.url === currentPath)
                )
              }
              onChange={handleChangeAccordion(index)}
            >
              <AccordionSummary
                expandIcon={<MdExpandMore size={26} />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <StyledSetting>
                  <ListItemIcon>
                    <MdSettings size={26} />
                  </ListItemIcon>
                  <ListItemText>{accordion.label}</ListItemText>
                </StyledSetting>
              </AccordionSummary>
              <StyledAccordionDetails>
                {accordion?.items.map((item, index) => (
                  <StyledDrawerLink
                    to={item.url}
                    $isActive={item.url === currentPath}
                    key={item.label}
                  >
                    <ListItem button>
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <ListItemText>{item.label}</ListItemText>
                    </ListItem>
                  </StyledDrawerLink>
                ))}
              </StyledAccordionDetails>
            </StyledAccordion>
          ))}
          <ListItem button onClick={AuthCTX.logout}>
            <ListItemIcon>
              <MdExitToApp size={26} />
            </ListItemIcon>
            <ListItemText>خروج</ListItemText>
          </ListItem>
        </StyledList>
      </StyledDrawer>

      <StyledMain open={open} $drawerWidth={drawerWidth}>
        <StyledDrawerHeader />
        {props.children}
      </StyledMain>
    </Box>
  );
}

DrawerCM.prototype = {
  title: PropTypes.string,
  onSearch: PropTypes.func,
};
